export default function CheckboxInputButton({
  className,
  emoji,
  id,
  name,
  onChange,
  title,
}: {
  className: string
  emoji: string
  id: string
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  title: string
}) {
  return (
    <div className="flex">
      <input
        className="peer hidden"
        id={id}
        name={name}
        onChange={onChange}
        type="checkbox"
        value={id}
      />

      <label
        className={`custom-button-input ${className} peer-checked:bg-[length:1000%_100%]`}
        htmlFor={id}
      >
        <span className="mr-1 text-3xl">{emoji}</span>

        <span>{title}</span>
      </label>
    </div>
  )
}
